import {Typography} from '@mui/material';
import {t} from 'i18next';
import React from 'react';
import useSTRStatus, {STRStatusType} from '../hook/useSTRStatus';
import {STRResultKPIType} from '../ViewSTR';
import STRElapsedTimer from './STRElapsedTimer';
import STRProgressBar from './STRProgressBar';

type Props = {
  status: STRStatusType | null;
  kpi: STRResultKPIType;
};

const stringPath = 'eca.searchTermReport.viewSTR.';

const STRReportStatusInfoContainer: React.FC<Props> = ({status, kpi}) => {
  const {StatusIcon, statusName, statusProgressBarShow} = useSTRStatus(status);

  const renderBadge = () => {
    return (
      <div className={`status-badge-container ${status}`} tabIndex={0}>
        {StatusIcon}
        <Typography className="typo-text body2_size">{statusName}</Typography>
      </div>
    );
  };
  return (
    <div className="view-str-status-container">
      <div className="view-str-status-left-container">
        <Typography className="typo-text subhead3_size status" tabIndex={0}>
          {t(stringPath + 'status')}
        </Typography>
        {renderBadge()}
      </div>
      {statusProgressBarShow && (
        <STRProgressBar
          completed={kpi.totalTermsCompleted ?? 0}
          total={kpi.totalNumOfTerms ?? 0}
        />
      )}
      <div className="view-str-status-right-container">
        <div className="status-inner-container">
          <Typography className="typo-text label2_size label" tabIndex={0}>
            {t(stringPath + 'completed')}
          </Typography>
          <Typography className="typo-text body2_size field" tabIndex={0}>
            {t(stringPath + 'processCount', {
              total: kpi.totalNumOfTerms ?? 0,
              complete: kpi.totalTermsCompleted ?? 0,
            })}
          </Typography>
        </div>
        <div className="status-inner-container">
          <Typography className="typo-text label2_size label" tabIndex={0}>
            {t(stringPath + 'elapsedTime')}
          </Typography>
          <STRElapsedTimer
            status={status}
            startTime={kpi.reportRunStartTime}
            endTime={kpi.reportRunEndTime}
          />
        </div>
      </div>
    </div>
  );
};

export default STRReportStatusInfoContainer;
